import GroupIcon from '@mui/icons-material/Group';
import { t } from 'i18next';
import CrudBase from "src/components/CrudBase";
import GenericInvoiceCatalog from 'src/models/genericInvoiceCatalog';
import GenericInvoiceCatalogForm from './GenericInvoiceCatalogForm';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import anyToString from "src/utils/anyToString";

export function GenericInvoiceCatalogs() {
    const queryParameters = new URLSearchParams(window.location.search);
    const targetUrl = "invoice/catalogs/import/index"+"?model="+queryParameters.get("catalog");
    return (
        <CrudBase<GenericInvoiceCatalog>
            resource="generic-invoice-catalogs"
            permissions={{
                'view' : 'invoice_catalogs.all',
                'list' : 'invoice_catalogs.all',
                'create' : 'invoice_catalogs.all',
                'edit' : 'invoice_catalogs.all',
                'delete' : 'invoice_catalogs.all',
            }}
            listUrl={targetUrl}
            indexColumns={['identifier', 'description', 'updated_at']}
            showModalColumns={[]}
            Form={GenericInvoiceCatalogForm}
            actionsColumn={false}
            createButton={true}
            showButton={false}
            editButton={false}
            deleteButton={false}
            searchInput={true}
            Icon={GroupIcon} />
    );
}
